import PrivateRoute, { OwnerRoute as OwnerRouteImport } from './PrivateRouteContainer';

export default PrivateRoute;
export const OwnerRoute = OwnerRouteImport;
